import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { Emdash } from "~/components/Punctuation";
import { AssetTableRowData } from "../types";
import { RWA_COIN_ICON } from "~/consts";
import { ImageLoader } from "~/components/ImageLoader";

// // // //

export const PEGGED_ASSET_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.peggedAssetName,
    label: "Currency",
    type: ColumnTypes.string,
    sortsOn: AssetColumns.peggedAssetName,
    width: 125,
    render: (item) => {
        if (item.isAsset) {
            if (!item.pegged_asset) return null;

            return (
                <div className="flex items-center gap-2 overflow-hidden">
                    <ImageLoader
                        src={item.pegged_asset.icon_url || RWA_COIN_ICON}
                        alt={`${item.pegged_asset.name} Icon`}
                        fallbackSrc={RWA_COIN_ICON}
                        className="size-5 min-w-5 rounded-full bg-white"
                        fallbackClassName="bg-white opacity-50"
                    />
                    <div className="dg-overflow">{item.pegged_asset.name}</div>
                </div>
            );
        }

        return null;
    },
};

export const PEGGED_COMMODITY_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: "pegged_commodity",
    label: "Pegged Commodity",
    type: ColumnTypes.string,
    sortsOn: AssetColumns.peggedAssetName,
    width: 200,
    render: (item) => {
        if (item.isAsset) {
            const peggedAsset = item.pegged_asset;

            if (!peggedAsset) return <Emdash />;

            return (
                <div className="flex items-center">
                    <div
                        className="size-3 min-w-3 rounded-full mr-2"
                        style={{
                            backgroundColor: peggedAsset.color_hex || "black",
                        }}
                    />
                    <p className="dg-overflow">
                        {peggedAsset.name}
                        {peggedAsset.unit && (
                            <span>&nbsp;({peggedAsset.unit})</span>
                        )}
                    </p>
                </div>
            );
        }

        return <Emdash />;
    },
};
